import React from 'react'

import classNames from 'classnames'

import style from './Footer.module.css'

import { ReactComponent as GitHubIcon } from 'assets/icons/social/github.svg'
import { ReactComponent as InstIcon } from 'assets/icons/social/inst.svg'
import { ReactComponent as WebIcon } from 'assets/icons/social/web.svg'
import { ReactComponent as YouTubeIcon } from 'assets/icons/social/youtube.svg'

type PropsType = {}

export const Footer = ({}: PropsType) => {
  return (
    <footer className={style.footer}>
      <div className={classNames('container', style.box)}>
        <p className={style.copyright}>
          © {new Date().getFullYear()}&nbsp;
          <a
            className={style['copyright-link']}
            href="https://it-incubator.io/"
            target="_blank"
            rel="noreferrer"
          >
            It-Incubator
          </a>
          <span className={style['copyright-extra-text']}>. All rights reserved</span>
        </p>
        <div className={style['links-box']}>
          <ul className={style.social}>
            <li>
              <a
                className={style.link}
                href="https://www.instagram.com/it.incubator/"
                target="_blank"
                rel="noreferrer"
              >
                <InstIcon />
                <span className="visually-hidden">Инстаграм</span>
              </a>
            </li>
            <li>
              <a
                className={style.link}
                href="https://it-incubator.io/"
                target="_blank"
                rel="noreferrer"
              >
                <WebIcon />
                <span className="visually-hidden">Сайт IT-Incubator</span>
              </a>
            </li>
            <li>
              <a
                className={style.link}
                href="https://www.youtube.com/c/ITINCUBATOR"
                target="_blank"
                rel="noreferrer"
              >
                <YouTubeIcon />
                <span className="visually-hidden">Youtube</span>
              </a>
            </li>
          </ul>
          <a
            className={style['github-link']}
            href="https://github.com/it-incubator/interview-questions-db/tree/develop"
            target="_blank"
            rel="noreferrer"
            title="Стать контрибьютером"
          >
            Внести свой вклад
            <GitHubIcon
              className={style['github-icon']}
              width="20"
              height="20"
              title="Стать контрибьютером"
            />
          </a>
        </div>
      </div>
    </footer>
  )
}
